module.exports = __webpack_public_path__ + "img/s1.1705db2.png";